import { Integration } from '@dadohr/shared/domainTypes/integrations';

export type IntegrationDescription = {
  name: string;
  // logo src etc...
};

export const INTEGRATION_DESCRIPTIONS: {
  [key in Integration]: IntegrationDescription;
} = {
  [Integration.AIRTABLE]: {
    name: 'Airtable'
  },
  [Integration.ADP_WORKFORCE_NOW]: {
    name: 'ADP Workforce Now'
  },
  [Integration.ASANA]: {
    name: 'Asana'
  },
  [Integration.ASHBY]: {
    name: 'Ashby'
  },
  [Integration.ATLASSIAN]: {
    name: 'Jira'
  },
  [Integration.BAMBOOHR]: {
    name: 'BambooHR'
  },
  [Integration.BOB]: {
    name: 'Bob'
  },
  [Integration.CALENDLY]: {
    name: 'Calendly'
  },
  [Integration.DOCEBO]: {
    name: 'Docebo'
  },
  [Integration.DOCUSIGN]: {
    name: 'Docusign'
  },
  [Integration.GOOGLE_SHEETS]: {
    name: 'Google'
  },
  [Integration.GREENHOUSE_V3]: {
    name: 'Greenhouse'
  },
  [Integration.PERSONIO]: {
    name: 'Personio'
  },
  [Integration.LESSONLY]: {
    name: 'Lessonly'
  },
  [Integration.MICROSOFT]: {
    name: 'Microsoft'
  },
  [Integration.MICROSOFT_ENTRA_SSO]: {
    name: 'Microsoft Entra SSO'
  },
  [Integration.SLACK]: {
    name: 'Slack'
  },
  [Integration.SWAG_UP]: {
    name: 'SwagUp'
  },
  [Integration.MERGE]: {
    name: 'Merge'
  },
  [Integration.OKTA]: { name: 'Okta' },
  [Integration.OKTA_API]: { name: 'Okta API' },
  [Integration.PINGBOARD]: { name: 'Pingboard' },
  [Integration.SFTP]: { name: 'SFTP' },
  [Integration.WORKDAY]: { name: 'Workday RaaS' },
  [Integration.WORKDAY_API]: { name: 'Workday API' },
  [Integration.UKG]: { name: 'UKG Pro' },
  [Integration.CHARTHOP]: {
    name: 'ChartHop'
  },
  [Integration.RIPPLING]: {
    name: 'Rippling'
  },
  [Integration.HIRERIGHT]: {
    name: 'HireRight'
  },
  [Integration.EMAIL_CSV]: {
    name: 'Email CSV'
  },
  [Integration.CHECKR]: {
    name: 'Checkr'
  },
  [Integration.SALESFORCE]: {
    name: 'Salesforce'
  }
};
